import React from 'react';
import { motion } from 'framer-motion';

const Clients = () => {
  const clientLogos = [
    'MailChimp',
    'PAYPAL', 
    'MICROSOFT',
    'DRIBBBLE',
    'GOOGLE'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Text */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Our Clients
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8">
              We work closely with leading brands across various industries. Our commitment to excellence 
              and innovative solutions has earned us the trust of companies worldwide. From startups to 
              Fortune 500 companies, we deliver exceptional results that exceed expectations and drive 
              sustainable growth through strategic design and development.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              className="bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-pink-600 transition-colors"
            >
              VIEW MORE
            </motion.button>
          </motion.div>

          {/* Right side - Client image and logos */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative z-10">
              <div className="bg-pink-100 rounded-full w-64 h-64 mx-auto flex items-center justify-center overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=250&h=250&fit=crop" 
                  alt="Happy client"
                  className="w-48 h-48 rounded-full object-cover"
                />
              </div>
            </div>

            {/* Client logos */}
            <div className="mt-8 grid grid-cols-3 gap-4">
              {clientLogos.map((logo, index) => (
                <motion.div
                  key={logo}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gray-50 p-4 rounded-lg text-center hover:bg-gray-100 transition-colors"
                >
                  <span className="text-gray-600 font-medium text-sm">{logo}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Clients;